// class CartManager {
//   constructor() {
//     this.init();
//   }

//   init() {
//     document.addEventListener('click', (e) => {
//       const btn = e.target.closest('[data-add-to-cart], .add-to-cart, .product-form__submit');
//       if (!btn) return;

//       e.preventDefault();

//       const form = btn.closest('form');
//       const variantId =
//         btn.dataset.variantId ||
//         btn.value ||
//         form?.querySelector('[name="id"]')?.value;

//       if (variantId) this.add(variantId, btn);
//     });

//     // ✅ Drawer close listeners
//     this.setupDrawerCloseListeners();
//     this.forceDrawerCheck();
//   }

//   async add(variantId, btn) {
//     btn.disabled = true;
//     const originalText = btn.textContent;
//     btn.textContent = 'Adding...';

//     try {
//       await fetch('/cart/add.js', {
//         method: 'POST',
//         headers: { 'Content-Type': 'application/json' },
//         body: JSON.stringify({
//           items: [{ id: parseInt(variantId), quantity: 1 }]
//         })
//       });

//       await this.refreshDrawer();
//       this.forceOpenDrawer();
//       this.runBaadMayCalculations();
//       this.forceDrawerCheck();

//     } catch (err) {
//       alert('Failed to add to cart');
//     } finally {
//       btn.textContent = originalText;
//       btn.disabled = false;
//     }
//   }

//   forceOpenDrawer() {
//     const drawer = document.querySelector('cart-drawer');
    
//     if (drawer) {
//       drawer.classList.add('is-active', 'active');
//       drawer.classList.remove('is-empty');
//       document.body.classList.add('overflow-hidden');
      
//       const openEvent = new CustomEvent('cart-drawer:open');
//       drawer.dispatchEvent(openEvent);
      
//       setTimeout(() => {
//         if (!drawer.classList.contains('is-active')) {
//           const cartIcon = document.querySelector('#cart-icon-bubble, .header__icon--cart, [data-cart-drawer-toggle]');
//           if (cartIcon) cartIcon.click();
//         }
//       }, 100);
      
//       drawer.style.transform = 'translateX(0)';
//       drawer.style.visibility = 'visible';
//       drawer.style.opacity = '1';
//     }
//   }

//   // ✅ Drawer close listeners setup
//   setupDrawerCloseListeners() {
//     document.addEventListener('click', (e) => {
//       // Close button pe click
//       if (e.target.closest('.drawer__close, [data-close-drawer], .drawer-close')) {
//         this.closeDrawer();
//         return;
//       }

//       // ✅ Overlay pe direct click
//       if (e.target.matches('.drawer-overlay, .cart-drawer-overlay, body > .overlay')) {
//         this.closeDrawer();
//         return;
//       }

//       // ✅ Cart drawer element pe click (background/overlay area)
//       const drawer = document.querySelector('cart-drawer');
//       if (drawer && drawer.classList.contains('is-active')) {
//         // Agar drawer pe click hua but inner content pe nahi
//         if (e.target === drawer && !e.target.closest('.drawer__inner, .drawer__content')) {
//           this.closeDrawer();
//         }
//       }
//     });

//     // ESC key press
//     document.addEventListener('keydown', (e) => {
//       if (e.key === 'Escape') {
//         const drawer = document.querySelector('cart-drawer');
//         if (drawer && drawer.classList.contains('is-active')) {
//           this.closeDrawer();
//         }
//       }
//     });
//   }

//   // ✅ Proper drawer close function
//   closeDrawer() {
//     const drawer = document.querySelector('cart-drawer');
    
//     if (drawer) {
//       // Remove all active classes
//       drawer.classList.remove('is-active', 'active');
//       document.body.classList.remove('overflow-hidden');
      
//       // Trigger close event
//       const closeEvent = new CustomEvent('cart-drawer:close');
//       drawer.dispatchEvent(closeEvent);
      
//       // Reset inline styles
//       drawer.style.transform = '';
//       drawer.style.visibility = '';
//       drawer.style.opacity = '';

//       // ✅ Remove overlay if exists
//       const overlay = document.querySelector('.drawer-overlay, .cart-drawer-overlay, body > .overlay');
//       if (overlay) {
//         overlay.remove();
//       }

//       // ✅ Alternative: Page refresh option
//       // window.location.reload();
//     }
//   }

//   async refreshDrawer() {
//     try {
//       const res = await fetch('/?sections=cart-drawer,cart-icon-bubble');
//       const sections = await res.json();

//       if (sections['cart-drawer']) {
//         const html = document.createElement('div');
//         html.innerHTML = sections['cart-drawer'];
//         const newDrawerContent = html.querySelector('.drawer__inner');
//         const currentDrawer = document.querySelector('cart-drawer .drawer__inner');
//         if (newDrawerContent && currentDrawer) {
//           currentDrawer.innerHTML = newDrawerContent.innerHTML;
//         }
//       }

//       if (sections['cart-icon-bubble']) {
//         const html = document.createElement('div');
//         html.innerHTML = sections['cart-icon-bubble'];
//         const newCount = html.querySelector('.cart-count-bubble');
//         const currentCount = document.querySelector('.cart-count-bubble');
//         if (newCount && currentCount) currentCount.innerHTML = newCount.innerHTML;
//       }

//       this.forceDrawerCheck();
      
//       // ✅ Re-attach close listeners after refresh
//       this.setupDrawerCloseListeners();

//     } catch (err) {
//       console.error('Failed to refresh drawer:', err);
//     }
//   }

//   runBaadMayCalculations() {
//     setTimeout(() => {
//       // BaadMay logic
//     }, 1000);
//   }

//   forceDrawerCheck() {
//     const drawer = document.querySelector('cart-drawer');
//     const cartItemsContainer = document.querySelector('#CartDrawer-CartItems');

//     if (drawer && cartItemsContainer) {
//       const hasItems = cartItemsContainer.children.length > 0;
//       if (hasItems && drawer.classList.contains('is-empty')) {
//         drawer.classList.remove('is-empty');
//       } else if (!hasItems && !drawer.classList.contains('is-empty')) {
//         drawer.classList.add('is-empty');
//       }
//     }
//   }
// }

// new CartManager();


class CartManager {
  constructor() {
    this.init();
  }

  init() {
    document.addEventListener('click', (e) => {
      const btn = e.target.closest('[data-add-to-cart], .add-to-cart, .product-form__submit');
      if (!btn) return;

      e.preventDefault();

      const form = btn.closest('form');
      const variantId =
        btn.dataset.variantId ||
        btn.value ||
        form?.querySelector('[name="id"]')?.value;

      if (variantId) this.add(variantId, btn);
    });

    // ✅ Drawer close listeners
    this.setupDrawerCloseListeners();
    this.forceDrawerCheck();
  }

  async add(variantId, btn) {
    btn.disabled = true;
    const originalText = btn.textContent;
    btn.textContent = 'Adding...';

    try {
      await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          items: [{ id: parseInt(variantId), quantity: 1 }]
        })
      });

      await this.refreshDrawer();
      this.forceOpenDrawer();
      this.runBaadMayCalculations();
      this.forceDrawerCheck();

    } catch (err) {
      alert('Failed to add to cart');
    } finally {
      btn.textContent = originalText;
      btn.disabled = false;
    }
  }

  forceOpenDrawer() {
    const drawer = document.querySelector('cart-drawer');
    
    if (drawer) {
      drawer.classList.add('is-active', 'active');
      drawer.classList.remove('is-empty');
      document.body.classList.add('overflow-hidden');
      
      const openEvent = new CustomEvent('cart-drawer:open');
      drawer.dispatchEvent(openEvent);
      
      setTimeout(() => {
        if (!drawer.classList.contains('is-active')) {
          const cartIcon = document.querySelector('#cart-icon-bubble, .header__icon--cart, [data-cart-drawer-toggle]');
          if (cartIcon) cartIcon.click();
        }
      }, 100);
      
      drawer.style.transform = 'translateX(0)';
      drawer.style.visibility = 'visible';
      drawer.style.opacity = '1';
    }
  }

  // ✅ Drawer close listeners setup
  setupDrawerCloseListeners() {
    document.addEventListener('click', (e) => {
      // Close button pe click
      if (e.target.closest('.drawer__close, [data-close-drawer], .drawer-close')) {
        this.closeDrawer();
        return;
      }

      // ✅ Overlay pe direct click
      if (e.target.matches('.drawer-overlay, .cart-drawer-overlay, body > .overlay')) {
        this.closeDrawer();
        return;
      }

      // ✅ Cart drawer element pe click (background/overlay area)
      const drawer = document.querySelector('cart-drawer');
      if (drawer && drawer.classList.contains('is-active')) {
        // Agar drawer pe click hua but inner content pe nahi
        if (e.target === drawer && !e.target.closest('.drawer__inner, .drawer__content')) {
          this.closeDrawer();
        }
      }
    });

    // ESC key press
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') {
        const drawer = document.querySelector('cart-drawer');
        if (drawer && drawer.classList.contains('is-active')) {
          this.closeDrawer();
        }
      }
    });
  }

  // ✅ Proper drawer close function
closeDrawer() {
  const drawer = document.querySelector('cart-drawer');
  
  if (drawer) {
    // Drawer classes remove
    drawer.classList.remove('is-active', 'active');
    document.body.classList.remove('overflow-hidden');

    // Trigger close event
    const closeEvent = new CustomEvent('cart-drawer:close');
    drawer.dispatchEvent(closeEvent);

    // Reset drawer styles
    drawer.style.transform = '';
    drawer.style.visibility = '';
    drawer.style.opacity = '';

    // ✅ Hide overlay ONLY when drawer close button is clicked
    const overlay = document.querySelector('.cart-drawer__overlay, .cart-drawer-overlay, body > .overlay');
    if (overlay) {
      // overlay.style.display = 'none'; // <-- yahan sirf hide kar rahe
    }
  }
}


  async refreshDrawer() {
    try {
      const res = await fetch('/?sections=cart-drawer,cart-icon-bubble');
      const sections = await res.json();

      if (sections['cart-drawer']) {
        const html = document.createElement('div');
        html.innerHTML = sections['cart-drawer'];
        const newDrawerContent = html.querySelector('.drawer__inner');
        const currentDrawer = document.querySelector('cart-drawer .drawer__inner');
        if (newDrawerContent && currentDrawer) {
          currentDrawer.innerHTML = newDrawerContent.innerHTML;
        }
      }

      if (sections['cart-icon-bubble']) {
        const html = document.createElement('div');
        html.innerHTML = sections['cart-icon-bubble'];
        const newCount = html.querySelector('.cart-count-bubble');
        const currentCount = document.querySelector('.cart-count-bubble');
        if (newCount && currentCount) currentCount.innerHTML = newCount.innerHTML;
      }

      this.forceDrawerCheck();
      
      // ✅ Re-attach close listeners after refresh
      this.setupDrawerCloseListeners();

    } catch (err) {
      console.error('Failed to refresh drawer:', err);
    }
  }

  runBaadMayCalculations() {
    setTimeout(() => {
      // BaadMay logic
    }, 1000);
  }

  forceDrawerCheck() {
    const drawer = document.querySelector('cart-drawer');
    const cartItemsContainer = document.querySelector('#CartDrawer-CartItems');

    if (drawer && cartItemsContainer) {
      const hasItems = cartItemsContainer.children.length > 0;
      if (hasItems && drawer.classList.contains('is-empty')) {
        drawer.classList.remove('is-empty');
      } else if (!hasItems && !drawer.classList.contains('is-empty')) {
        drawer.classList.add('is-empty');
      }
    }
  }
}

new CartManager();







class CartRemoveButton extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('click', (event) => {
      // BaadMay code start for cart drawer
      setTimeout(() => {
        var domainShop = "bata-pakistan.myshopify.com";
      
        function calculateCartInstallment() {
            var storedData = sessionStorage.getItem("baadmayData");
      
            if (storedData) {
                processData(JSON.parse(storedData));
            } else {
                fetch("https://cms.baadmay.com/Fees?merchant_name=" + domainShop)
                  .then(response => response.json())
                  .then(data => {
                      sessionStorage.setItem("baadmayData", JSON.stringify(data));
                      processData(data);
                  })
                  .catch(error => console.error("Error fetching data:", error));
            }
        }
      
        function processData(result) {
            var valAdd = result[0].fee;
            var divVal = parseInt(valAdd) / 100;
            sessionStorage.setItem("percentageAmount", divVal);
            var perctoAddCartPage1 = sessionStorage.getItem("percentageAmount");
      
            var priceDivideElements = document.querySelectorAll('baadmaypricerre');
            priceDivideElements.forEach(priceDivideElement => {
                var cartPageTotal1 = parseFloat(priceDivideElement.getAttribute('total-cart-price'));
                var multiCartPrice1 = cartPageTotal1 * perctoAddCartPage1;
                var finalCartPrice1 = Math.floor(parseFloat(cartPageTotal1 + multiCartPrice1) / 3);
      
                priceDivideElement.textContent = parseFloat(finalCartPrice1).toLocaleString();
            });
        }
      
        calculateCartInstallment();
        
        var venobox = new VenoBox({
          selector: '.baadmay-modal',
          closeColor: '#000',
          closeBackground: 'transparent',
          overlayColor: 'rgba(0,0,0,.75)',
          overlayClose: false,
          customClass: 'baadmay-modal-container',
        });
      
        document.addEventListener('click', function(event) {
          if (event.target.classList.contains('baadmay-popup-close')) {
            venobox.close();
          }
        });
      }, 1500); 
      // BaadMay code end for cart drawer
      event.preventDefault();
      const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');
      cartItems.updateQuantity(this.dataset.index, 0);
    });
  }
}

customElements.define('cart-remove-button', CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();
    this.lineItemStatusElement =
      document.getElementById('shopping-cart-line-item-status') || document.getElementById('CartDrawer-LineItemStatus');

    const debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, ON_CHANGE_DEBOUNCE_TIMER);

    this.addEventListener('change', debouncedOnChange.bind(this));
  }

  cartUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      if (event.source === 'cart-items') {
        return;
      }
      this.onCartUpdate();
    });
  }

  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
  }

  onChange(event) {
    this.updateQuantity(event.target.dataset.index, event.target.value, document.activeElement.getAttribute('name'));
  }

  onCartUpdate() {
    fetch(`${routes.cart_url}?section_id=main-cart-items`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const sourceQty = html.querySelector('cart-items');
        this.innerHTML = sourceQty.innerHTML;
      })
      .catch((e) => {
        console.error(e);
      });
  }

  getSectionsToRender() {
    return [
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items').dataset.id,
        selector: '.js-contents',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
      {
        id: 'cart-icon-bubble-bar',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section',
      },
      {
        id: 'main-cart-footer',
        section: document.getElementById('main-cart-footer').dataset.id,
        selector: '.js-contents',
      },
    ];
  }

  updateQuantity(line, quantity, name) {
    // BaadMay code start for cart drawer
    setTimeout(() => {
      var domainShop = "bata-pakistan.myshopify.com";
    
      function calculateCartInstallment() {
          var storedData = sessionStorage.getItem("baadmayData");
    
          if (storedData) {
              processData(JSON.parse(storedData));
          } else {
              fetch("https://cms.baadmay.com/Fees?merchant_name=" + domainShop)
                .then(response => response.json())
                .then(data => {
                    sessionStorage.setItem("baadmayData", JSON.stringify(data));
                    processData(data);
                })
                .catch(error => console.error("Error fetching data:", error));
          }
      }
    
      function processData(result) {
          var valAdd = result[0].fee;
          var divVal = parseInt(valAdd) / 100;
          sessionStorage.setItem("percentageAmount", divVal);
          var perctoAddCartPage1 = sessionStorage.getItem("percentageAmount");
    
          var priceDivideElements = document.querySelectorAll('baadmaypricerre');
          priceDivideElements.forEach(priceDivideElement => {
              var cartPageTotal1 = parseFloat(priceDivideElement.getAttribute('total-cart-price'));
              var multiCartPrice1 = cartPageTotal1 * perctoAddCartPage1;
              var finalCartPrice1 = Math.floor(parseFloat(cartPageTotal1 + multiCartPrice1) / 3);
    
              priceDivideElement.textContent = parseFloat(finalCartPrice1).toLocaleString();
          });
      }
    
      calculateCartInstallment();
      
      var venobox = new VenoBox({
        selector: '.baadmay-modal',
        closeColor: '#000',
        closeBackground: 'transparent',
        overlayColor: 'rgba(0,0,0,.75)',
        overlayClose: false,
        customClass: 'baadmay-modal-container',
      });
    
      document.addEventListener('click', function(event) {
        if (event.target.classList.contains('baadmay-popup-close')) {
          venobox.close();
        }
      });
    }, 1500); 
    // BaadMay code end for cart drawer
    
    this.enableLoading(line);

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    });

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
        const quantityElement =
          document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`);
        const items = document.querySelectorAll('.cart-item');

        if (parsedState.errors) {
          quantityElement.value = quantityElement.getAttribute('value');
          this.updateLiveRegions(line, parsedState.errors);
          return;
        }

        this.classList.toggle('is-empty', parsedState.item_count === 0);
        const cartDrawerWrapper = document.querySelector('cart-drawer');
        const cartFooter = document.getElementById('main-cart-footer');

        if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
        if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);

        this.getSectionsToRender().forEach((section) => {
          const elementToReplace =
            document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
          elementToReplace.innerHTML = this.getSectionInnerHTML(
            parsedState.sections[section.section],
            section.selector
          );
        });
        const updatedValue = parsedState.items[line - 1] ? parsedState.items[line - 1].quantity : undefined;
        let message = '';
        if (items.length === parsedState.items.length && updatedValue !== parseInt(quantityElement.value)) {
          if (typeof updatedValue === 'undefined') {
            message = window.cartStrings.error;
          } else {
            message = window.cartStrings.quantityError.replace('[quantity]', updatedValue);
          }
        }
        this.updateLiveRegions(line, message);

        const lineItem =
          document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);
        if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
          cartDrawerWrapper
            ? trapFocus(cartDrawerWrapper, lineItem.querySelector(`[name="${name}"]`))
            : lineItem.querySelector(`[name="${name}"]`).focus();
        } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper.querySelector('.drawer__inner-empty'), cartDrawerWrapper.querySelector('a'));
        } else if (document.querySelector('.cart-item') && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper, document.querySelector('.cart-item__name'));
        }
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items' });
      })
      .catch(() => {
        this.querySelectorAll('.loading-overlay').forEach((overlay) => overlay.classList.add('hidden'));
        const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
        errors.textContent = window.cartStrings.error;
      })
      .finally(() => {
        this.disableLoading(line);
      });
  }

  updateLiveRegions(line, message) {
    const lineItemError =
      document.getElementById(`Line-item-error-${line}`) || document.getElementById(`CartDrawer-LineItemError-${line}`);
    if (lineItemError) lineItemError.querySelector('.cart-item__error-text').innerHTML = message;

    this.lineItemStatusElement.setAttribute('aria-hidden', true);

    const cartStatus =
      document.getElementById('cart-live-region-text') || document.getElementById('CartDrawer-LiveRegionText');
    cartStatus.setAttribute('aria-hidden', false);

    setTimeout(() => {
      cartStatus.setAttribute('aria-hidden', true);
    }, 1000);
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  enableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.add('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading-overlay`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading-overlay`);

    [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) => overlay.classList.remove('hidden'));

    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute('aria-hidden', false);
  }

  disableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.remove('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading-overlay`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading-overlay`);

    cartItemElements.forEach((overlay) => overlay.classList.add('hidden'));
    cartDrawerItemElements.forEach((overlay) => overlay.classList.add('hidden'));
  }
}

customElements.define('cart-items', CartItems);

if (!customElements.get('cart-note')) {
  customElements.define(
    'cart-note',
    class CartNote extends HTMLElement {
      constructor() {
        super();

        this.addEventListener(
          'change',
          debounce((event) => {
            const body = JSON.stringify({ note: event.target.value });
            fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
          }, ON_CHANGE_DEBOUNCE_TIMER)
        );
      }
    }
  );
}
